import { withLocale, NOT_FOUND_PATH, canonicalizeAppPath } from '@/util/categoryRoute'

// 其他路由配置
const otherRoutes = [
  {
    path: withLocale('/other'),
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: withLocale('/404'),
        name: 'Please visit other pages',
        component: () => import('@/views/error/404.vue'),
        meta: {
          cnName: '页面不存在',
          enName: 'Page Not Found'
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)',
    redirect: (to) => {
      const canonicalPath = canonicalizeAppPath(to.path)
      if (canonicalPath !== to.path) {
        return { path: canonicalPath, query: to.query, hash: to.hash }
      }
      return { path: NOT_FOUND_PATH }
    }
  },

  {
    path: withLocale('/OCR'),
    name: 'OCR',
    component: () => import('@/views/customerService/ocr/index.vue'),
    meta: {
      cnName: 'OCR页面',
      enName: 'OCR Page'
    }
  },
  {
    path: withLocale('/orderInvoice'),
    name: 'orderInvoice',
    component: () => import('@/views/order/invoice/index.vue'),
    meta: {
      cnName: '发票',
      enName: 'invoice'
    }
  },
  {
    path: withLocale('/series'),
    name: 'series',
    component: () => import('@/views/customerService/series/index.vue'),
    meta: {
      cnName: 'series',
      enName: 'series'
    }
  },
  {
    path: withLocale('/series/side-by-series'),
    name: 'side-by-series',
    component: () => import('@/views/customerService/series/side-by-series.vue'),
    meta: {
      cnName: 'side-by-series',
      enName: 'series'
    }
  },
  {
    path: withLocale('/series/single-door-series'),
    name: 'single-door-series',
    component: () => import('@/views/customerService/series/single-door-series.vue'),
    meta: {
      cnName: 'single-door-series',
      enName: 'series'
    }
  },
  {
    path: withLocale('/series/t-door-series'),
    name: 't-door-series',
    component: () => import('@/views/customerService/series/t-door-series.vue'),
    meta: {
      cnName: 't-door-series',
      enName: 'series'
    }
  }
]

export default otherRoutes
